import React, { useState, useEffect, useRef } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Button, Drawer, Input, Form } from 'antd'
import notification from 'mrx-notification'
import { useCreateCustomerSubscriptionNote } from '../../hooks'
import { PropsFromRedux, connector } from './container'
import styles from './CreateCustomerSubscriptionNote.module.scss'

type Props = PropsFromRedux & {
  customerSubscriptionId?: number
  className?: string
}

const CreateCustomerSubscriptionNote = (props: Props) => {
  const { customerSubscriptionId, className, workspaceId } = props

  const [isVisible, setVisible] = useState(false)
  const refEl = useRef<Input>(null)

  const createCustomerSubscriptionNote = useCreateCustomerSubscriptionNote()

  useEffect(() => {
    if (isVisible) {
      refEl.current && refEl.current.focus()
    }
  }, [isVisible])

  const showDrawer = () => {
    setVisible(!isVisible)
  }

  const [form] = Form.useForm()

  const handleClose = () => {
    setVisible(false)
    form.resetFields()
  }

  useEffect(() => {
    if (createCustomerSubscriptionNote.isSuccess) {
      notification.success({
        message: 'Successfully',
        description: 'Customer Subscription Note was created successfully!'
      })
      handleClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createCustomerSubscriptionNote.isSuccess])

  const onFinishHandler = async (values: any) => {
    createCustomerSubscriptionNote.mutate({
      workspaceId,
      note: values.note,
      customerSubscriptionId: customerSubscriptionId
    })
  }

  return (
    <>
      <Button className={className} type='primary' onClick={showDrawer}>
        <PlusOutlined />
        CREATE NOTE
      </Button>
      <Drawer title='Create Note' width='400' onClose={handleClose} visible={isVisible} forceRender>
        <Form layout='vertical' hideRequiredMark onFinish={onFinishHandler} form={form}>
          <Form.Item name='note' label='Note' rules={[{ required: true, message: 'Please input note!' }]}>
            <Input style={{ width: '100%' }} ref={refEl} />
          </Form.Item>

          <div className={styles.buttonsContainer}>
            <Button onClick={handleClose} className={styles.createButton}>
              Close
            </Button>
            <Button type='primary' htmlType='submit' loading={createCustomerSubscriptionNote.isLoading}>
              Create
            </Button>
          </div>
        </Form>
      </Drawer>
    </>
  )
}

export default connector(CreateCustomerSubscriptionNote)
